import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Burly} from 'kb-burly';
import {MsalService} from '@azure/msal-angular';
import {TypedPaginationResponse} from '../../../responses';
import {TeardownReport} from '../index';
import {RequestQueryBuilder, SCondition} from '@nestjsx/crud-request';

@Injectable({
  providedIn: 'root'
})
export class TorchTdrService {

  currentUserEmailAddress: string;

  constructor(protected config: TorchAPIConfiguration,
              private httpClient: HttpClient,
              private msalService: MsalService) {

    this.currentUserEmailAddress = this.msalService.instance.getActiveAccount().username;
  }

  getLibraryDownloadURL(report: TeardownReport) {
    return Burly(this.config.filesUrl)
      .addSegment('/files/download/')
      .addSegment(report.fileName)
      .addQuery('container', 'tdr')
      .get;
  }

  getLibraryBulkDownloadURL(reports: TeardownReport[]) {
    return Burly(this.config.filesUrl)
      .addSegment('/files/multiple/download/')
      .addQuery('fileNames', reports.map(report => report.fileName).join(','))
      .addQuery('container', 'tdr')
      .get;
  }

  searchVendors(vendorName: string) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tdr/documents/vendors')
      .addQuery('vendor', vendorName)
      .get;

    return this.httpClient.get<string[]>(endpointURL);
  }

  searchRepairTypesLibrary(repairType: string) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tdr/documents/repairTypes')
      .addQuery('repairType', repairType)
      .get;

    return this.httpClient.get<string[]>(endpointURL);
  }

  searchRepairTypesExplorer(repairType: string) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tdr/explorer/repairTypes')
      .addQuery('repairType', repairType)
      .get;

    return this.httpClient.get<string[]>(endpointURL);
  }


  listDownloadedReports(page: number = 0,
                        pageSize: number = 50,
                        sortBy: string = 'removalDate',
                        sortDirection: 'ASC' | 'DESC' = 'DESC',
                        filters: SCondition | null): Observable<TypedPaginationResponse<TeardownReport>> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(page).setLimit(pageSize).sortBy({field: sortBy, order: sortDirection});

    if (!!filters) {
      qb.search(filters);
    }

    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tdr/documents')
      .appendRawQueryString(qb.query(false))
      .get;


    return this.httpClient.get<TypedPaginationResponse<TeardownReport>>(endpointURL);
  }
}
